(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/objectWithoutPropertiesLoose", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@h3yun/request", "lodash/cloneDeep", "crypto", "@h3yun/global-provider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/objectWithoutPropertiesLoose"), require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@h3yun/request"), require("lodash/cloneDeep"), require("crypto"), require("@h3yun/global-provider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.createClass, global.objectWithoutPropertiesLoose, global.regenerator, global.asyncToGenerator, global.request, global.cloneDeep, global.crypto, global.globalProvider);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _createClass2, _objectWithoutPropertiesLoose2, _regenerator, _asyncToGenerator2, _request, _cloneDeep, _crypto, _globalProvider) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports.ModouService = ModouService;
  _exports.actionConfig = actionConfig;
  _exports.createCacheStore = createCacheStore;
  _exports.createContext = createContext;
  _exports.createDomainBase = createDomainBase;
  _exports.createRouter = createRouter;
  _exports.createScope = createScope;
  _exports.defineDomain = defineDomain;
  _exports.CacheBase = _exports.ActionCacheStatus = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _request = _interopRequireDefault(_request);
  _cloneDeep = _interopRequireDefault(_cloneDeep);
  _crypto = _interopRequireDefault(_crypto);

  function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  /**
   * @packageDocumentation
   * @module sdk-core.middleware
   */
  function use(context) {
    var maps = {};
    var type = 'before';

    if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === 'object') {
      maps = arguments.length <= 1 ? undefined : arguments[1];
      type = (arguments.length <= 2 ? undefined : arguments[2]) || 'before';
    } else if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1 && typeof (arguments.length <= 1 ? undefined : arguments[1]) === 'string') {
      var _maps;

      maps = (_maps = {}, _maps[arguments.length <= 1 ? undefined : arguments[1]] = arguments.length <= 2 ? undefined : arguments[2], _maps);
      type = (arguments.length <= 3 ? undefined : arguments[3]) || 'before';
    }

    context.middlewares = context.middlewares || {};
    Object.entries(maps).forEach(function (_ref) {
      var key = _ref[0],
          handler = _ref[1];

      if (context.middlewares[key]) {
        type === 'before' && context.middlewares[key].push(handler);
        type !== 'before' && context.middlewares[key].unshift(handler);
      } else {
        context.middlewares[key] = [handler];
      }
    });
  }

  function before(context, key, handler) {
    return context.use(context, key, function beforeHandler(actionContext, payload, next) {
      return Promise.resolve(handler(actionContext, payload)).then(next);
    }, 'before');
  }

  function after(context, key, handler) {
    return context.use(context, key, function afterHandler(actionContext, payload, next) {
      return next().then(function (result) {
        handler(actionContext, payload);
        return result;
      });
    }, 'after');
  }

  function middlewareFactory(context) {
    return {
      use: use.bind(context, context),
      before: before.bind(context, context),
      after: after.bind(context, context)
    };
  }
  /**
   * @packageDocumentation
   * @module sdk-core.context
   */


  var ModouContextStatus;

  (function (ModouContextStatus) {
    ModouContextStatus["UNLOAD"] = "UNLOAD";
    ModouContextStatus["LOADING"] = "LOADING";
    ModouContextStatus["LOADED"] = "LOADED";
  })(ModouContextStatus || (ModouContextStatus = {}));
  /**
   * @internal
   */


  function createContext(scope, base) {
    var resultProto = {};
    var store = base.store,
        domainKey = base.domainKey,
        refs = base.refs,
        caches = base.caches,
        globalOnly = base.globalOnly,
        model = base.model,
        service = base.service,
        actions = base.actions;
    var modelTemplate = model;
    resultProto.service = service;
    resultProto.domainKey = domainKey;
    var context = Object.create(resultProto);
    context.scopeId = scope._id;
    context.middlewares = {
      "default": []
    };
    var middlewareProto = middlewareFactory(context);
    Object.assign(resultProto, middlewareProto);
    var clonedContext = Object.create(context);
    Object.assign(clonedContext, (0, _cloneDeep["default"])(modelTemplate));
    clonedContext.__STATUS__ = ModouContextStatus.UNLOAD;
    var middlewares = {}; // 获取生成action对象的方法

    Object.keys(actions).forEach(function (actionKey) {
      resultProto[actionKey] = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, extra) {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", store.dispatch(domainKey + "/" + actionKey, {
                    middlewares: middlewares,
                    context: context,
                    clonedContext: clonedContext,
                    params: params,
                    scope: scope,
                    base: base,
                    extra: extra
                  }));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }();
    });
    /**  load执行：
      *      执行unlink旧的code
      *      判断refs中，是否有当前namespace的监听器
      *      如果有，不做处理；
      *      如果没有，创建一个，将observer传入，并创建contexts，数组；
      */

    middlewares.load = [/*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(actionContext, code, next) {
        var actionDomainKey, actionContextKey, namespace, oldNamespace, rootState, observable, resultPromise, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                actionDomainKey = context.domainKey;
                actionContextKey = globalOnly ? actionDomainKey : code; // 判断namespace，根据domain是否全局唯一

                namespace = globalOnly ? actionDomainKey : actionContextKey ? actionDomainKey + "." + actionContextKey : '';
                oldNamespace = globalOnly ? actionDomainKey : context.contextKey ? actionDomainKey + "." + context.contextKey : '';
                rootState = actionContext.rootState; // 如果两者不等
                // if (namespace !== oldNamespace) {

                if (oldNamespace && namespace !== oldNamespace) {
                  unlinkRefWithContext(oldNamespace, clonedContext, actionContext, refs, caches);
                }

                if (namespace) {
                  // load方法因为是初始化方法，所以此处需要重新覆盖contextKey
                  actionContext.contextKey = actionContextKey;
                  context.contextKey = actionContextKey;

                  if (!globalOnly && !rootState[actionDomainKey][actionContextKey]) {
                    rootState[actionDomainKey][actionContextKey] = (0, _cloneDeep["default"])(modelTemplate);
                  } // extra中可以指定参数observable , 使context不响应式更新


                  observable = !(actionContext.extra && !actionContext.extra.observable);

                  if (observable) {
                    linkRefWithContext(namespace, clonedContext, refs);
                  } // 因为中间件执行顺序问题，这里需要将actionContext的state重新赋值


                  actionContext.state = globalOnly ? rootState[actionDomainKey] : rootState[actionDomainKey][actionContextKey];

                  if ('code' in actionContext.state && code) {
                    actionContext.state.code = code;
                  }
                }

                resultPromise = next(); // load 方法特殊处理，在执行之后，立刻做数据同步

                Object.assign(clonedContext, (0, _cloneDeep["default"])(actionContext.state));
                clonedContext.__STATUS__ = ModouContextStatus.LOADING;
                _context2.next = 12;
                return resultPromise;

              case 12:
                result = _context2.sent;
                clonedContext.__STATUS__ = ModouContextStatus.LOADED;
                return _context2.abrupt("return", result);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }()];
    middlewares.unload = [function (actionContext) {
      var modelEmpty = (0, _cloneDeep["default"])(modelTemplate);
      Object.assign(clonedContext, modelEmpty);
      var actionDomainKey = context.domainKey;
      var actionContextKey = context.contextKey;
      var namespace = globalOnly ? actionDomainKey : actionDomainKey + "." + actionContextKey;
      unlinkRefWithContext(namespace, clonedContext, actionContext, refs, caches);
      context.contextKey = '';
      clonedContext.__STATUS__ = ModouContextStatus.UNLOAD;
    }];
    return clonedContext;
  }
  /**
   * @hidden
   */


  function unlinkRefWithContext(namespace, context, actionContext, refs, caches) {
    var refsObj = refs[namespace];

    if (refsObj && refsObj.contexts) {
      var contexts = refsObj.contexts;

      if (contexts.has(context)) {
        contexts["delete"](context);
      }

      if (contexts.size === 0) {
        // 如果引用计数为0, 删除引用的key
        delete refs[namespace];
        caches.clearContextCache(context.contextKey);
        var actionDomainKey = context.domainKey;
        var actionContextKey = context.contextKey; // 引用计数为0，将state上的数据删掉

        var rootState = actionContext.rootState;
        var domainState = rootState[actionDomainKey];

        if (actionContextKey && domainState[actionContextKey]) {
          delete domainState[actionContextKey];
        }
      }
    }
  }

  function linkRefWithContext(namespace, context, refs) {
    var refsObj = refs[namespace];

    if (refsObj) {
      refsObj.contexts.add(context);
    } else {
      var contexts = new Set([context]);
      refs[namespace] = {
        contexts: contexts
      };
    }
  }
  /**
   * createContext 创建context
   *      添加load中间件和unload中间件
   *
   * load执行：
   *      执行unlink旧的code
   *      判断refs中，是否有当前namespace的监听器
   *      如果有，不做处理；
   *      如果没有，创建一个，将observer传入，并创建contexts，数组；
   */

  /**
   * @packageDocumentation
   * @module sdk-core.router
   */


  function createRouter(routerOptions) {
    return {
      push: function push(loacation) {
        return routerOptions.push(loacation);
      },
      replace: function replace(loacation) {
        return routerOptions.replace(loacation);
      },
      go: function go(n) {
        return routerOptions.go(n);
      },
      back: function back() {
        routerOptions.back();
      },
      forward: function forward() {
        routerOptions.forward();
      }
    };
  } // This alphabet uses `A-Za-z0-9_-` symbols. The genetic algorithm helped
  // optimize the gzip compression for this alphabet.


  var urlAlphabet = 'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW'; // It is best to make fewer, larger requests to the crypto module to
  // avoid system call overhead. So, random numbers are generated in a
  // pool. The pool is a Buffer that is larger than the initial random
  // request size by this multiplier. The pool is enlarged if subsequent
  // requests exceed the maximum buffer size.

  var POOL_SIZE_MULTIPLIER = 32;
  var pool, poolOffset;

  var random = function random(bytes) {
    if (!pool || pool.length < bytes) {
      pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);

      _crypto["default"].randomFillSync(pool);

      poolOffset = 0;
    } else if (poolOffset + bytes > pool.length) {
      _crypto["default"].randomFillSync(pool);

      poolOffset = 0;
    }

    var res = pool.subarray(poolOffset, poolOffset + bytes);
    poolOffset += bytes;
    return res;
  };

  var nanoid = function nanoid(size) {
    if (size === void 0) {
      size = 21;
    }

    var bytes = random(size);
    var id = ''; // A compact alternative for `for (var i = 0; i < step; i++)`.

    while (size--) {
      // It is incorrect to use bytes exceeding the alphabet size.
      // The following mask reduces the random byte in the 0-255 value
      // range to the 0-63 value range. Therefore, adding hacks, such
      // as empty string fallback or magic numbers, is unneccessary because
      // the bitmask trims bytes down to the alphabet size.
      id += urlAlphabet[bytes[size] & 63];
    }

    return id;
  };
  /**
   * @packageDocumentation
   * @module sdk-core.scope
   */


  function createScope(options, baseMap, parentScope) {
    if (!options) {
      throw new Error('useScope 参数不可为空');
    }

    var customRequest = options.request,
        router = options.router,
        middlewares = options.middlewares,
        domainOptions = (0, _objectWithoutPropertiesLoose2["default"])(options, ["request", "router", "middlewares"]);
    var scope = {
      _id: nanoid(6),
      middlewares: middlewares || []
    };
    scope.request = customRequest || _request["default"];

    if (router) {
      scope.router = createRouter(router);
    }

    Object.entries(domainOptions).forEach(function (_ref4) {
      var contextName = _ref4[0],
          contextOptions = _ref4[1];

      // 传入配置则创建Context
      if (contextOptions) {
        var name = contextOptions.name,
            domain = contextOptions.domain;
        var domainBase = baseMap[domain];

        if (domainBase) {
          // 如果设置了globalOnly则直接取全局Scope上的
          scope[name] = domainBase.globalOnly && parentScope ? parentScope[name] : createContext(scope, domainBase);
        }
      } else if (parentScope) {
        // 配置传空，则直接从parentScope上获取
        scope[contextName] = parentScope[contextName];
      }
    });

    scope.destroy = function (clearHistory) {
      if (clearHistory === void 0) {
        clearHistory = false;
      }

      if (clearHistory) {
        Object.values(baseMap).forEach(function (base) {
          if (!base.globalOnly) {
            Object.values(base.refs).forEach(function (ref) {
              for (var _iterator = _createForOfIteratorHelperLoose(ref.contexts), _step; !(_step = _iterator()).done;) {
                var ctx = _step.value;

                if (ctx && ctx.scopeId === scope._id) {
                  ctx.unload();
                }
              }
            });
          }
        });
      } else {
        Object.values(scope).forEach(function (ctx) {
          if (ctx && ctx.scopeId === scope._id) {
            ctx.unload();
          }
        });
      }
    };

    var cacheStore = baseMap.Caches.store;

    scope.useCaches = function (state) {
      if (state) {
        return cacheStore.dispatch('Caches/setState', state);
      }

      return cacheStore.dispatch('Caches/getState');
    };

    return scope;
  }
  /**
   * @packageDocumentation
   * @module sdk-core.cache
   */


  var ActionCacheStatus;
  _exports.ActionCacheStatus = ActionCacheStatus;

  (function (ActionCacheStatus) {
    ActionCacheStatus["NOTPATCH"] = "NOTPATCH";
    ActionCacheStatus["PATCHING"] = "PATCHING";
    ActionCacheStatus["FINISHED"] = "FINISHED";
    ActionCacheStatus["CACHED"] = "CACHED";
    ActionCacheStatus["CACHEFETCHING"] = "CACHEFETCHING";
    ActionCacheStatus["ERROR"] = "ERROR";
  })(ActionCacheStatus || (_exports.ActionCacheStatus = ActionCacheStatus = {}));
  /**
   * @internal
   */


  var CacheManager = /*#__PURE__*/function () {
    function CacheManager(cacheStore, contextKey, actionKey) {
      this.actionConfig = null;
      this.contextKey = '';
      this.actionKey = '';
      this._cacheStore = null;
      this._cacheStore = cacheStore;
      this.contextKey = contextKey;
      this.actionKey = actionKey;
    }

    var _proto = CacheManager.prototype;

    _proto.getCacheItem = function getCacheItem() {
      if (!this._cacheStore) return null;

      var cacheItem = this._cacheStore.dispatch('Caches/getActionCache', {
        contextKey: this.contextKey,
        actionKey: this.actionKey
      });

      if (!cacheItem) {
        return this.setCacheItem({
          status: ActionCacheStatus.NOTPATCH
        });
      }

      return cacheItem;
    };

    _proto.setCacheItem = function setCacheItem(cacheItem) {
      if (!this._cacheStore) return null;
      return this._cacheStore.dispatch('Caches/setActionCache', {
        contextKey: this.contextKey,
        actionKey: this.actionKey,
        actionCache: cacheItem
      });
    };

    _proto.clearCacheItem = function clearCacheItem() {
      if (!this._cacheStore) return null;

      this._cacheStore.dispatch('Caches/clearActionCache', {
        contextKey: this.contextKey,
        actionKey: this.actionKey
      });
    };

    _proto.changeStatus = function changeStatus(status) {
      if (!this._cacheStore) return null;

      this._cacheStore.dispatch('Caches/changeStatus', {
        contextKey: this.contextKey,
        actionKey: this.actionKey,
        status: status
      });
    };

    (0, _createClass2["default"])(CacheManager, [{
      key: "__STATUS__",
      get: function get() {
        var cacheItem = this.getCacheItem();
        return cacheItem ? cacheItem.status : ActionCacheStatus.NOTPATCH;
      }
    }]);
    return CacheManager;
  }();

  var CacheBase = /*#__PURE__*/function () {
    function CacheBase(cacheStore) {
      this._cacheStore = cacheStore;
    }

    var _proto2 = CacheBase.prototype;

    _proto2.appendActionCache = function appendActionCache(contextKey, actionKey) {
      if (!this[contextKey]) {
        this[contextKey] = {};
      }

      this[contextKey][actionKey] = new CacheManager(this._cacheStore, contextKey, actionKey);
      return this[contextKey][actionKey];
    };

    _proto2.getActionCache = function getActionCache(contextKey, actionKey) {
      var cache = this[contextKey] && this[contextKey][actionKey];

      if (!cache) {
        cache = this.appendActionCache(contextKey, actionKey);
      }

      return this[contextKey] && this[contextKey][actionKey];
    };

    _proto2.clearContextCache = function clearContextCache(contextKey) {
      if (!this._cacheStore) return null;

      if (this[contextKey]) {
        delete this[contextKey];
      }

      this._cacheStore.dispatch('Caches/clearContextCache', {
        contextKey: contextKey
      });
    };

    return CacheBase;
  }();

  _exports.CacheBase = CacheBase;

  function createCacheStore(state) {
    return (0, _globalProvider.useStore)({
      state: state || {},
      actions: {
        getState: function getState(store) {
          return store.state;
        },
        setState: function setState(store, targetState) {
          if (targetState) {
            Object.assign(store.state, targetState);
          }

          return store.state;
        },
        getContextCache: function getContextCache(store, contextKey) {
          return store.state[contextKey];
        },
        getActionCache: function getActionCache(store, _ref5) {
          var contextKey = _ref5.contextKey,
              actionKey = _ref5.actionKey;
          return store.state[contextKey] && store.state[contextKey][actionKey];
        },
        setContextCache: function setContextCache(store, _ref6) {
          var key = _ref6.key,
              contextCache = _ref6.contextCache;
          store.state[key] = contextCache;
          return contextCache;
        },
        setActionCache: function setActionCache(store, _ref7) {
          var contextKey = _ref7.contextKey,
              actionKey = _ref7.actionKey,
              actionCache = _ref7.actionCache;

          if (!store.state[contextKey]) {
            store.state[contextKey] = {};
          }

          store.state[contextKey][actionKey] = actionCache;
          return actionCache;
        },
        clearContextCache: function clearContextCache(store, _ref8) {
          var contextKey = _ref8.contextKey;

          if (store.state[contextKey]) {
            return delete store.state[contextKey];
          }

          return false;
        },
        clearActionCache: function clearActionCache(store, _ref9) {
          var contextKey = _ref9.contextKey,
              actionKey = _ref9.actionKey;

          if (store.state[contextKey] && store.state[contextKey][actionKey]) {
            return delete store.state[contextKey][actionKey];
          }

          return false;
        },
        changeStatus: function changeStatus(store, _ref10) {
          var contextKey = _ref10.contextKey,
              actionKey = _ref10.actionKey,
              status = _ref10.status;

          if (store.state[contextKey] && store.state[contextKey][actionKey]) {
            store.state[contextKey][actionKey].status = status;
          }
        },
        resetCacheState: function resetCacheState(store, _ref11) {
          var callback = _ref11.callback;

          if (typeof callback === 'function') {
            var result = callback(store.state);

            if (result) {
              store.state = result;
            }
          }

          return (0, _cloneDeep["default"])(store.state);
        }
      }
    }, 'Caches');
  }
  /**
   * @hidden
   */


  function createActionCacheHandler(config, handler) {
    // TODO: 增强cachedPool
    return /*#__PURE__*/function () {
      var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(context, params) {
        var cacheHandler, canReuseByParams, base, cacheBase, contextKey, actionKey, cacheManager, cacheItem, result, resultData, resultPromise, isCacheReuseByParams;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cacheHandler = config.cacheHandler, canReuseByParams = config.canReuseByParams;
                base = context.base;
                cacheBase = base.caches;
                contextKey = context.contextKey, actionKey = context.actionKey;

                if (contextKey && actionKey) {
                  cacheManager = cacheBase.getActionCache(contextKey, actionKey);
                  cacheItem = cacheManager.getCacheItem();
                }

                if (cacheManager) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", handler(context, params));

              case 7:
                cacheItem = cacheItem || {
                  status: ActionCacheStatus.NOTPATCH
                };

                isCacheReuseByParams = function isCacheReuseByParams() {
                  // 若有canReuseByParams，则动态执行控制缓存
                  return (canReuseByParams ? canReuseByParams(context, params) : true) && ( // 若有useCache，则使用useCache参数控制缓存
                  params ? params.useCache !== false : true);
                };

                if (!(cacheItem.status === ActionCacheStatus.PATCHING && isCacheReuseByParams())) {
                  _context3.next = 14;
                  break;
                }

                cacheManager.changeStatus(ActionCacheStatus.CACHEFETCHING);
                return _context3.abrupt("return", cacheManager.cachedPromise);

              case 14:
                if (!(cacheItem.status === ActionCacheStatus.CACHED && isCacheReuseByParams())) {
                  _context3.next = 21;
                  break;
                }

                cacheManager.changeStatus(ActionCacheStatus.CACHEFETCHING);
                resultData = cacheHandler && cacheHandler(context, params);
                result = {
                  data: resultData,
                  isCache: true
                };
                cacheManager.changeStatus(ActionCacheStatus.CACHED);
                _context3.next = 28;
                break;

              case 21:
                cacheManager.changeStatus(ActionCacheStatus.PATCHING);
                resultPromise = handler(context, params);
                cacheManager.cachedPromise = resultPromise;
                _context3.next = 26;
                return resultPromise;

              case 26:
                result = _context3.sent;

                if (result.errorCode) {
                  cacheManager.changeStatus(ActionCacheStatus.NOTPATCH);
                } else {
                  cacheManager.changeStatus(ActionCacheStatus.CACHED);
                }

              case 28:
                return _context3.abrupt("return", result);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x6, _x7) {
        return _ref12.apply(this, arguments);
      };
    }();
  }
  /**
   * @packageDocumentation
   * @module sdk-core.compose
   */
  // export default namespace compose {
  //     type Middleware<T> = (context: T, next: Next) => any;
  //     type ComposedMiddleware<T> = (context: T, next?: Next) => Promise<void>;
  // }

  /**
   * Compose `middleware` returning
   * a fully valid middleware comprised
   * of all those which are passed.
   *
   * @param {Array} middleware
   * @return {Function}
   * @api public
   */


  function compose(middleware) {
    if (!Array.isArray(middleware)) throw new TypeError('Middleware stack must be an array!');

    for (var _iterator2 = _createForOfIteratorHelperLoose(middleware), _step2; !(_step2 = _iterator2()).done;) {
      var fn = _step2.value;
      if (typeof fn !== 'function') throw new TypeError('Middleware must be composed of functions!');
    }
    /**
     * @param {Object} context
     * @return {Promise}
     * @api public
     */


    return function (context, params, next) {
      // last called middleware #
      var index = -1;
      return dispatch(0);

      function dispatch(i) {
        if (i <= index) return Promise.reject(new Error('next() called multiple times'));
        index = i;
        var fn = middleware[i];
        if (i === middleware.length) fn = next;
        if (!fn) return Promise.resolve();

        try {
          return Promise.resolve(fn(context, params, dispatch.bind(null, i + 1)));
        } catch (err) {
          return Promise.reject(err);
        }
      }
    };
  }
  /**
   * @packageDocumentation
   * @module sdk-core.store
   */

  /**
   * 创建store数据管理
   */


  function createBaseStore(domainKey, actions, actionConfigs, initialState) {
    if (actions === void 0) {
      actions = {};
    }

    actionConfigs.unload = {};
    var actionsMap = Object.entries(actionConfigs).reduce(function (current, _ref13) {
      var actionKey = _ref13[0],
          config = _ref13[1];

      var actionHandler = actions[actionKey] || config["default"] || function () {};

      actionHandler = config.cacheHandler ? createActionCacheHandler(config, actionHandler) : actionHandler;

      current[actionKey] = function actionDef(store, payload) {
        var context = payload.context,
            scope = payload.scope,
            params = payload.params,
            base = payload.base,
            middlewares = payload.middlewares,
            extra = payload.extra;
        var state = store.state;
        var contextKey = context.contextKey;
        var actionState = base.globalOnly ? state : state[contextKey];
        var actionContext = Object.create(context);
        var actionMiddlewares = context.middlewares[actionKey] || [];
        var payloadMiddleware = middlewares && middlewares[actionKey] || [];
        actionContext.state = actionState;
        actionContext.rootState = store.rootState;
        actionContext.contextKey = contextKey;
        actionContext.actionKey = actionKey;
        actionContext.scope = scope;
        actionContext.base = base;
        actionContext.extra = extra;

        actionContext.getValue = function () {
          return actionContext.state;
        }; // 获取cache中间件


        return compose([].concat(payloadMiddleware, [stateMiddleware], scope.middlewares, context.middlewares["default"], actionMiddlewares))(actionContext, params, actionHandler);
      };

      return current;
    }, {});
    var store = (0, _globalProvider.useStore)({
      state: initialState || {},
      actions: actionsMap
    }, domainKey);
    return store;
  }

  function standardlizeResponse(result) {
    if (result === void 0) {
      result = {};
    }

    if (result instanceof Error) {
      return result;
    }

    return Object.assign({}, result, {
      data: (0, _cloneDeep["default"])(result.data)
    });
  }

  function stateMiddleware(_x8, _x9, _x10) {
    return _stateMiddleware.apply(this, arguments);
  }

  function _stateMiddleware() {
    _stateMiddleware = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(context, params, next) {
      var result;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              context.cache = context.base.caches.getActionCache(context.contextKey, context.actionKey);
              _context4.next = 3;
              return next();

            case 3:
              result = _context4.sent;
              syncStateToRefs(context);
              return _context4.abrupt("return", standardlizeResponse(result));

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _stateMiddleware.apply(this, arguments);
  }

  function syncStateToRefs(context) {
    if (context.base && context.base.refs) {
      var _context$base$refs$na;

      var clonedState = (0, _cloneDeep["default"])(context.state);
      var namespace = context.base.globalOnly ? context.base.domainKey : context.base.domainKey + "." + context.contextKey;
      var contexts = (_context$base$refs$na = context.base.refs[namespace]) == null ? void 0 : _context$base$refs$na.contexts;

      if (contexts) {
        for (var _iterator3 = _createForOfIteratorHelperLoose(contexts), _step3; !(_step3 = _iterator3()).done;) {
          var ctx = _step3.value;
          Object.assign(ctx, clonedState);
        }
      }
    }
  }
  /**
   * @packageDocumentation
   * @module sdk-core.domain
   */


  function defineDomain(definition) {
    return definition;
  }

  function createDomainBase(options, definition, cacheStore) {
    var state = options.state,
        actions = options.actions;
    var actionConfigs = definition.actions;
    var baseStore = createBaseStore(definition.domainKey, actions, actionConfigs, state);
    return (0, _extends2["default"])({
      store: baseStore,
      refs: {}
    }, definition, {
      caches: new CacheBase(cacheStore)
    });
  }
  /**
   * @packageDocumentation
   * @module sdk-core.action
   */

  /**
   * @hidden
   */


  function actionConfig(config) {
    config.unload = {};
    return config;
  }
  /**
   * @packageDocumentation
   * @module sdk-core.service
   */


  function ModouService(serviceDef) {
    return serviceDef;
  }
});
